export const CheckSvg: React.FC<React.SVGProps<SVGSVGElement>> = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_3296_46837)">
      <path
        d="M19.5353 3.26877C18.9165 2.64915 17.9116 2.64954 17.292 3.26877L7.19573 13.3654L2.70838 8.87812C2.08875 8.25849 1.08435 8.25849 0.46472 8.87812C-0.154907 9.49775 -0.154907 10.5022 0.46472 11.1218L6.07367 16.7307C6.38329 17.0404 6.78928 17.1956 7.1953 17.1956C7.60133 17.1956 8.00771 17.0407 8.31733 16.7307L19.5353 5.5124C20.1549 4.8932 20.1549 3.88836 19.5353 3.26877Z"
        fill="currentColor"
      />
    </g>
  </svg>
);
